import {DrawReference} from '@platform/ui/DrawReference';
import {drawNumber} from '@platform/contracts/drawNumber';
import {SalesCount} from '@platform/ui/SalesCount';
import {useCopy,useUi} from '@platform/ui/config';
import {PeopleIcon} from '@platform/ui/PeopleIcon';
import {QuickSelectionButton} from './QuickSelectionButton';
import {BottomCta} from './BottomCta';
import type {Snapshot} from '@platform/contracts/x';
import {PurchaseDeadline} from './PurchaseDeadline';
import {useOwnedCardsMeta} from './useOwnedCardsMeta';

// The main sales screen offers quick selection. The next-draw catalogue owns
// its return action separately, so it cannot accidentally inherit a countdown.
export function PurchaseSelectionPrompt({state,onQuick,disabled}:{state:Snapshot;onQuick:()=>void;disabled:boolean}){
 const t=useCopy(),ui=useUi(),sold=state.purchaseCount?.toLocaleString(ui.controls.prizeDisplayLocale)??'—';
 const ownedMeta=useOwnedCardsMeta(state);
 return <BottomCta className="room-next-action" revealKey={state.drawId} handleLabel={t('room.drawStartingPrompt')} handleDetail={<DrawReference draw={drawNumber(state)}/>} handleMeta={ownedMeta} data-ui="purchase-selection-prompt">
  <div className="purchase-selection-actions">
   <PurchaseDeadline state={state} compact hideTimerLabel/>
   <span className="purchase-selection-sales bottom-cta-sales" data-ui="purchase-total-sold" aria-label={t('x.purchaseCount',{count:sold})} title={t('x.purchaseCount',{count:sold})}><PeopleIcon/><b><SalesCount count={state.purchaseCount} identity={state.drawId}/></b></span>
   <QuickSelectionButton className="purchase-selection-prompt bottom-navigation-action" label={t('room.selectCardsPrompt')} disabled={disabled} onClick={onQuick}/>
  </div>
 </BottomCta>;
}
